import React, { useEffect } from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Rating } from "react-simple-star-rating";

const Testimonials = ({ ourcustomersays }) => {
  const testimonials = [
    {
      name: "Swapnil Joshi",
      image: "/assets/images/home/testimonials/img-1.png",
      review:
        "The chikki quality is amazing and tastes completely homemade. Fresh, crunchy, and perfect for healthy snacking.",
      rating: 5,
    },
    {
      name: "Nisha Patil",
      image: "/assets/images/home/testimonials/img-2.png",
      review:
        "I ordered dry fruit laddus from Nutricos and my family loved them. Great taste with premium ingredients.",
      rating: 4.5,
    },
    {
      name: "Sneha Kulkarni",
      image: "/assets/images/home/testimonials/img-3.png",
      review:
        "Healthy snacks with authentic flavor. The packaging was neat and delivery was quick.",
      rating: 5,
    },
    {
      name: "Vikram Joshi",
      image: "/assets/images/home/testimonials/img-1.png",
      review:
        "The peanut chikki was fresh and perfectly balanced in sweetness. Definitely ordering again.",
      rating: 4,
    },
    {
      name: "Pooja Shah",
      image: "/assets/images/home/testimonials/img-2.png",
      review:
        "Nutricos laddus are tasty, nutritious, and ideal for daily energy. Loved the quality and freshness.",
      rating: 5,
    },
  ];

  return (
    <section className="Testimonials">
      <div className="container">
        <div className="What_Customer_Say_div">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-4">
              <div className="col_left_div">
                <div className="qoute_div">
                  <img
                    src="/assets/images/home/testimonials/quote.png"
                    className="quote_img"
                  />
                </div>

                <div className="left_title_div">
                  <h5 className="left_title">
                    What <br /> Our Customers Say
                  </h5>
                  <p className="left_text">
                    Trusted by families and businesses who love our quality
                    products and reliable service.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-8">
              <div className="testimonial_section">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={30}
                  slidesPerView={3}
                  loop={true}
                  breakpoints={{
                    0: { slidesPerView: 1.1 },
                    320: { slidesPerView: 1.1 },
                    440: { slidesPerView: 2.1},
                    576: { slidesPerView: 2.1 },
                    768: { slidesPerView: 2.1 },
                    992: { slidesPerView: 2.1 },
                    1200: { slidesPerView: 3.1 },
                    1400: { slidesPerView: 3.1 },
                    1700: { slidesPerView: 3.1 },
                  }}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                >
                  {testimonials && testimonials.length > 0 ? (
                    testimonials?.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="testimonial_card">
                          <div className="user_header_div">
                            <div className="user_img_div">
                              <img
                                src={process.env.PUBLIC_URL + item.image}
                                alt={item?.name}
                                className="user_img"
                              />
                            </div>

                            <div className="name_holder">
                              <h5 className="user_name">{item?.name}</h5>

                              <div className="stars">
                                <Rating
                                  initialValue={item?.rating || 0}
                                  size={18}
                                  allowFraction={true}
                                  readonly={true}
                                  fillColor="#52883e"
                                  emptyColor="#ddd"
                                />
                              </div>
                            </div>
                          </div>

                          <p className="review_text">{item?.review}</p>
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <div className="no-products-message">
                        <p>
                          <strong>No Data available</strong>
                        </p>
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
